import React from "react";
import {
  FaPlane,
  FaKaaba,
  FaShieldAlt,
  FaRedo,
  FaFileAlt,
  FaStamp,
  FaHotel,
} from "react-icons/fa";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();

  const servicesIcons = [
    <FaPlane className="text-sky-400 w-10 h-10" aria-label="Air Ticket Booking" />,
    <FaKaaba className="text-sky-400 w-10 h-10" aria-label="Umrah Services" />,
    <FaShieldAlt className="text-sky-400 w-10 h-10" aria-label="Travel Insurance" />,
    <FaRedo className="text-sky-400 w-10 h-10" aria-label="Ticket Reissuing" />,
    <FaFileAlt className="text-sky-400 w-10 h-10" aria-label="Online Form Assistance" />,
    <FaStamp className="text-sky-400 w-10 h-10" aria-label="Apostille Appointment" />,
  ];

  return (
    <section
      id="services"
      className="relative py-16 sm:py-20 text-white bg-gradient-to-b from-[#001020] via-[#021b33] to-[#002a44] overflow-hidden"
    >
      {/* Soft background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(56,189,248,0.15),transparent_70%)] pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center relative z-10">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            {t("services.heading")}
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-sky-400 to-blue-500 mx-auto mb-8 rounded-full shadow-[0_0_15px_#38bdf8]" />
          <p className="text-gray-300 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">
            {t("services.subheading")}
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10 mt-12 sm:mt-16">
          {t("services.items", { returnObjects: true }).map((service, index) => (
            <motion.div
              key={index}
              className="bg-[#0b1e2e]/80 rounded-xl p-5 sm:p-6 border border-[#1e3a56]
                         hover:border-sky-400 hover:shadow-[0_0_25px_rgba(56,189,248,0.4)]
                         transition-all duration-300 text-center flex flex-col items-center"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mb-3 sm:mb-4">{servicesIcons[index]}</div>
              <h3 className="text-lg sm:text-xl font-semibold mb-2 text-sky-300">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                {service.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
